import { Tag } from 'antd'
import React from 'react'
import { NOT_AVAILABLE } from 'utils/constants'

export enum RegistryStatus {
  REGISTERED = 'Registered',
  UNREGISTERED = 'Unregistered',
  LATE_REGISTERED = 'LateRegistration',
  EXPIRED_REGISTRATION = 'ExpiredRegistration',
}

interface RegistryStatusTagProps {
  status?: RegistryStatus
}

const RegistryStatusTag = ({ status }: RegistryStatusTagProps) => {
  if (!status) return <>{NOT_AVAILABLE}</>

  // Map status to color and label
  const statusConfig: Record<RegistryStatus, { color: string; variant?: string; label: string }> = {
    [RegistryStatus.REGISTERED]: { color: 'green', label: 'Registered' },
    [RegistryStatus.UNREGISTERED]: { color: 'red', label: 'Unregistered' },
    [RegistryStatus.LATE_REGISTERED]: { color: 'gold', label: 'Late Registered' },
    [RegistryStatus.EXPIRED_REGISTRATION]: { color: 'default', variant: 'outlined', label: 'Expired Registration' },
  }

  const config = statusConfig[status]
  if (!config) return <>{NOT_AVAILABLE}</>

  return <Tag color={config.color}>{config.label}</Tag>
}

export default RegistryStatusTag
